import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "api";
import { ValidateUserTokenRequestBody } from "api/models/Profile/profileModel";
import { toastError, toastSuccess } from "hooks/useToastify";
import {
  getChannelList,
  getHiveComponents,
  getHiveDetails,
} from "../Hive/hivePage";

export const getProfile = createAsyncThunk(
  "profile/getProfile",
  async (body: null, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await api.profile.getProfile();
      // dispatch(getGeoInfo(null));
      return data;
    } catch (error) {
      return rejectWithValue("Something went wrong");
    }
  }
);

export const refreshToken = createAsyncThunk(
  "profile/refreshToken",
  async (body: null, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await api.profile.refreshToken();
      dispatch(getProfile(null));
      window.location.reload();
      if (data.responseInfo.httpCode === 200) {
        toastSuccess("refreshed with 200");
        // dispatch(DispatchInitializeNoAuthApp(null));
        dispatch(
          getHiveDetails({
            // organizationUuid: process.env.REACT_APP_ORG_UUID,
            communitySubDomain: localStorage.getItem("subDomain")!,
          })
        );

        dispatch(
          getHiveComponents({
            // organizationUuid: process.env.REACT_APP_ORG_UUID,

            communityDomain: localStorage.getItem("subDomain"),
          })
        );
      }
      return data;
    } catch (error) {
      window.location.reload();
      return rejectWithValue("Something went wrong");
    }
  }
);

export const getProfileDetails = createAsyncThunk(
  "profile/getProfileDetails",
  async (
    body: {
      userId: number;
    },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await api.profile.getProfileDetails(body);
      return data.data;
    } catch (error) {
      return rejectWithValue("Something went wrong");
    }
  }
);

export const changeUserInfo = createAsyncThunk(
  "profile/changeUserInfo",
  async (body: { userName: string }, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await api.profile.changeUserInfo(body);
      // setTimeout(() => {
      dispatch(getProfile(null));
      // }, 1000);
      if (data.responseInfo.httpCode !== 200) {
        toastError(data.responseInfo.message);
      }
      return data.data;
    } catch (error) {}
  }
);

export const updateUserEmail = createAsyncThunk(
  "profile/updateUserEmail",
  async (body: { email: string }, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await api.profile.updateUserEmail(body);
      dispatch(getProfile(null));
      if (data.responseInfo.httpCode !== 200) {
        toastError(data.responseInfo.message);
      }
      return data.data;
    } catch (error) {
      return rejectWithValue("Something went wrong");
    }
  }
);

export const updateUserPhone = createAsyncThunk(
  "profile/updateUserPhone",
  async (
    body: { mobileNo: string; countryCode: string },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const { data } = await api.profile.updateUserPhone(body);
      dispatch(getProfile(null));
      if (data.responseInfo.httpCode !== 200) {
        toastError(data.responseInfo.message);
      }
      return data.data;
    } catch (error) {
      return rejectWithValue("Something went wrong");
    }
  }
);

export const validateToken = createAsyncThunk(
  "profile/validateToken",
  async (body: ValidateUserTokenRequestBody, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await api.profile.validateUserUsingToken(body);
      const { accessToken } = data?.data || {};
      localStorage.setItem("@jwtToken", accessToken);
      dispatch(getProfile(null));
      return data.data;
    } catch (error) {
      return rejectWithValue("Something went wrong");
    }
  }
);

export const getGeoInfo = createAsyncThunk(
  "profile/getGeoInfo",
  async (body: null, { rejectWithValue, dispatch }) => {
    try {
      const data = await api.profile.getGeoInfo();

      return data;
    } catch (error) {
      return rejectWithValue("Something went wrong");
    }
  }
);
